<template>
  <div>
    <el-card>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
          >Panel</el-breadcrumb-item
        >
        <el-breadcrumb-item
          v-if="nameTable"
          :to="{ path: '/dashboard/' + $route.params.db + '/list/' + table }"
          >{{ nameTable }}</el-breadcrumb-item
        >
        <el-breadcrumb-item v-if="form">Editando registro</el-breadcrumb-item>
        <el-breadcrumb-item v-else>Nuevo registro</el-breadcrumb-item>
      </el-breadcrumb>
      <br />
      <h2>{{ nameTable }}</h2>
      <i
        v-if="tableAjax.length > 0"
        class="custom__icon"
        :class="open ? 'icon-cerrar' : 'icon-ver_mas02'"
        @click="toggle()"
      ></i>
      <el-form
        v-if="!loading"
        @submit.native.prevent="submit"
        ref="form"
        label-position="top"
        id="form"
        v-show="open"
      >
        <el-row type="flex" justify="space-between">
          <el-col v-for="(f, i) in form" :key="i" :span="col(f)" v-if="f.field != 'id'">
            <app-item-form :f="f" :options="options"></app-item-form>
          </el-col>
        </el-row>

        <el-form-item>
          <button type="submit" class="el-button el-button--primary">
            <span>{{ btn }}</span>
          </button>
          <el-button @click="atras()">Atrás</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <template v-if="tableAjax && id">
      <el-card v-for="(table, index) in tableAjax" :key="index" class="my-5">
        <app-ajax-form
          :table="table.table"
          :multiple="table.multiple ? table.multiple : false"
          :template="table.template ? table.template : false"
          :edit="table.edit ? table.edit : false"
          :row="table.row ? table.row : false"
        ></app-ajax-form>
      </el-card>
    </template>
  </div>
</template>

<script>
import sha1 from "sha1";
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import itemForm from "@/components/Dashboard/forms/itemForm";
import formAjax from "@/components/Dashboard/forms/formajax";
import moment from "moment-timezone";

export default {
  name: "editForm",
  components: {
    "app-item-form": itemForm,
    "app-ajax-form": formAjax,
  },
  computed: {
    ...mapGetters(["getNameSidebar"]),
  },
  created() {
    setTimeout(() => {
      this.nameTable = this.getNameSidebar;
    }, 1000);
    this.$root.$on("imagenCargada", (file) => (this.file = file));
    this.$root.$on("imagenEliminada", () => (this.file = false));
    this.$root.$on("load-doc", (doc, field) => {
      this.documentos_subidos.push({ doc, field });
      //this.doc = doc;
    });

    this.$root.$on("delete-doc", (doc, field) => {
      this.doc = doc;

      let i = this.form.findIndex((o) => o.field === field);
      console.log(i);
      this.form[i].value = "";
    });

    this.$route.params.id ? (this.id = this.$route.params.id) : (this.id = false);
    this.$route.params.id ? (this.btn = "Actualizar") : (this.btn = "Crear");
    this.$route.params.table
      ? (this.table = this.$route.params.table)
      : (this.table = false);

    this.initApi();
  },
  beforeDestroy() {
    this.$root.$off("imagenCargada", (file) => (this.file = file));
    this.$root.$off("imagenEliminada", () => (this.file = false));
    this.$root.$off("load-doc", (doc, field) => {
      this.documentos_subidos.push({ doc, field });
      //this.doc = doc;
    });
    this.$root.$off("delete-doc", (doc, field) => {
      this.doc = doc;

      let i = this.form.findIndex((o) => o.field === field);
      console.log(i);
      this.form[i].value = "";
    });
  },
  data() {
    return {
      imagenes_subidas: [],
      documentos_subidos: [],
      loading: true,
      nameTable: "",
      img_transparency: false,
      id: false,
      table: false,

      form: [],
      field: {},
      datos: null,
      headers: [],
      relationship: [],
      tableInfo: null,
      image: false,
      file: false,
      options: {
        img: null,
        size: 1,
        full: true,
        outputType: "png",
        canMove: true,
        fixedBox: false,
        original: false,
        canMoveBox: false,
        class: "cropper-medium",
      },
      field: [],
      value: [],
      formEdit: {},
      tableAjax: [],
      document: null,
      doc: false,
      open: true,
    };
  },
  methods: {
    async initApi() {
      await this.getInfoBread();
      await this.getEditTable();
      await this.mountTable();
      await this.getListTable();
      this.loading = false;
    },
    async getInfoBread() {
      const response = await ApiService.post("dashboard/getinfobread", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (response) {
        this.tableInfo = response.data;
        this.showForm = true;
      }
    },
    async getEditTable() {
      const response = await ApiService.post("dashboard/getbread", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      this.field = response.data.data;
    },
    async getListTable() {
      let data = {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        relationship: this.relationship,
        header: this.headers,
      };

      this.id ? (data.id = this.id) : false;

      const response = await ApiService.post("dashboard/listtable", data);
      if (response) {
        this.datos = response.data;
        for (const element of this.headers) {
          //this.headers.forEach((element, i) => {
          if (element.pivot && this.$route.params.id) {
            const d = await ApiService.post("dashboard/table", {
              table: element.pivot[0].table,
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              row: element.pivot[0].keys[0][1],
              id: parseInt(this.$route.params.id),
            });

            if (d.data != "Algo ha fallado") {
              let value = d.data.map((v) => v[element.path]);
              this.form.push({
                type: element.type,
                field: element.path,
                name: element.name,
                label: element.title,
                value: value,
                key: element.key,
                pivot: element.pivot,
                options: element.options,
              });
            } else {
              this.form.push({
                type: element.type,
                field: element.path,
                name: element.name,
                label: element.title,
                value: this.datos[element.path],
                key: element.key,
                pivot: element.pivot,
                options: element.options,
              });
            }
          } else {
            this.form.push({
              type: element.type,
              field: element.path,
              name: element.name,
              label: element.title,
              value: this.datos[element.path],
              key: element.key,
              pivot: element.pivot,
              options: element.options,
            });
          }
        }
      }
    },
    async getOptionsSelect(data, e) {
      const response = await ApiService.post("dashboard/selectoptions", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        header: this.headers,
        relationship: data,
      });
      if (response) {
        this.headers.push({
          title: e.name,
          path: e.field,
          type: e.type,
          pivot: data.relationship.pivot,
          key: data.relationship.options[0].key,
          options: response.data,
        });
      }
    },
    async mountTable() {
      let relationship = [this.table];
      let i = 0;
      for (const e of this.field) {
        //await this.field.forEach((e, i) => {
        if (i != 0) {
          if (e.visibility["edit"]) {
            if (e.options.length > 0) {
              for (let index = 0; index < e.options.length; index++) {
                if (e.options[index].relationship) {
                  let data = {
                    relationship: e.options[index].relationship,
                  };
                  await this.getOptionsSelect(data, e);
                  await this.relationship.push(data);
                }
                if (e.options[index].ajax) {
                  if (e.options[index].multiple) {
                    if (e.options[index].template) {
                      this.tableAjax.push({
                        table: e.field,
                        multiple: true,
                        row: e.options[index].key,
                        template: e.options[index].template,
                      });
                    } else {
                      this.tableAjax.push({
                        table: e.field,
                        multiple: true,
                        edit: e.options[index].multiple
                          ? e.options[index].multiple
                          : false,
                        row: e.options[index].key,
                      });
                    }
                  } else {
                    if (e.options[index].template) {
                      this.tableAjax.push({
                        table: e.field,
                        row: e.options[index].key,
                        template: e.options[index].template,
                      });
                    } else {
                      this.tableAjax.push({
                        table: e.field,
                        row: e.options[index].key,
                      });
                    }
                  }
                }
              }
            } else {
              this.headers.push({
                title: e.name,
                path: e.field,
                type: e.type,
                key: false,
                options: e.options,
              });
            }
          }
        }
        i++;
      }
    },
    col(v) {
      switch (v.type) {
        case "texto_enriquecido":
          return 24;
          break;
        case "file":
          this.document = {
            field: v.field,
            value: v.value,
          };

          return 11;
          break;
        case "image":
          this.image = {
            field: v.field,
            value: v.value,
          };
          this.options.img = API_UPLOADS + v.value;
          return 24;
          break;
        default:
          return 11;
          break;
      }
    },
    async uploadFile(data) {
      const response = await ApiService.post("upload/contenido", data);
      return response.data;
    },
    async submit() {
      if (this.image != false) {
        if (this.file != false) {
          let file = new FormData();
          file.append("file", this.file);
          await ApiService.post("upload/contenido", file).then((response) => {
            this.image.value = response.data;
            let a = this.form.filter((form) => {
              if (form.field == this.image.field) {
                form.value = this.image.value;
              }
            });
          });
        }
      }
      if (this.documentos_subidos.length > 0) {
        for (const i of this.documentos_subidos) {
          console.log(i);
          if (i.doc[0].size) {
            console.log(i);
            let data = new FormData();
            data.append("file", i.doc[0].raw);
            data.append("type", "file");
            data.append("domain", localStorage.getItem("project"));
            let documento = await this.uploadFile(data);
            this.form.filter((form) => {
              if (form.field == i.field) {
                form.value = documento;
              }
            });
          }
        }
      }

      let pivot = [];
      this.formEdit = this.form.map((form) => {
        if (!this.id && form.pivot && form.value.length > 0) {
          pivot.push({ pivot: form.pivot[0], val: form.value });
        } else {
          if (form.type == "date") {
            form.value
              ? (form.value = moment(form.value).tz("Europe/Madrid").format("YYYY-MM-DD"))
              : false;
          }

          return {
            field: form.field,
            value: form.value,
            type: form.type,
          };
        }
      });

      const response = await ApiService.post("dashboard/editformdinamic", {
        table: this.table,
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.id,
        form: this.formEdit,
      });
      if (response) {
        if (response.data != "Algo ha fallado") {
          let title, message;
          this.id ? (title = "Registro modificado") : (title = "Registro creado");
          this.id
            ? (message = "Se ha modifcado la entrada con éxito")
            : (message = "Se ha creado la entrada con éxito");

          // Parche para añdir al usuario a la tabla de accesos
          console.log("newuser", !this.id && this.table == "users");
          if (!this.id && this.table == "users") {
            // parche para que al añadir un usuario se marque como leidas todas las notificaciones.
            ApiService.post("dashboard/utils/marcar-todas-notificaciones-leidas", {
              table: "access",
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
              id: parseInt(response.data),
            });
          }

          if (pivot.length > 0) {
            pivot.filter((p) => {
              let form = Object.create({});
              form[p.pivot.keys[0][1]] = parseInt(response.data);
              p.val.filter((v) => {
                setTimeout(() => {
                  form[p.pivot.keys[0][2]] = v;
                  ApiService.post("dashboard/editform", {
                    table: p.pivot.table,
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                    form: form,
                  });
                }, 300);
              });
            });
          }
          this.$notify({ title: title, message: message, type: "success" });
          setTimeout(() => {
            this.$router.push(
              "/dashboard/" + this.$route.params.db + "/list/" + this.table
            );
          }, 1500);
        } else {
          this.$notify.error({
            title: "Fallo",
            message: "Ago ha fallado y no se ha modificado la entrada",
          });
        }
      }
    },
    atras() {
      this.$router.go(-1);
    },
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style>
.el-select {
  width: 100%;
}
.el-row {
  flex-flow: row wrap;
}
.el-card {
  position: relative;
}
.custom__icon {
  position: absolute;
  font-size: 30px;
  top: 15px;
  right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/editForm.vue